import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ACTIVITY_FIELDS, QUICK } from "@/components/DailyActivityPanel";
import { todayStr } from "@/components/Pager";
import { Users } from "lucide-react";

const FIELDS = ACTIVITY_FIELDS.filter(([k]) => ["food_intake", "nap_time", "washroom", "behavior"].includes(k));

export function WholeClassQuick({ groups, onDone }) {
  const keys = Object.keys(groups);
  const [cls, setCls] = useState(keys[0]);
  const [busy, setBusy] = useState(false);
  const kids = groups[cls] || groups[keys[0]] || [];
  async function apply(field, label, value) {
    if (!window.confirm(`Mark "${value}" (${label}) for all ${kids.length} children in ${cls || keys[0]}?`)) return;
    setBusy(true);
    try {
      const r = await api.post("/student-updates/quick-all", { date: todayStr(), field, value, student_ids: kids.map((s) => s.id) });
      const { created, updated, skipped } = r.data;
      toast.success(`${label}: "${value}" saved for ${created + updated} children — sent for approval${skipped ? ` · ${skipped} skipped (logged by another teacher)` : ""}`);
      onDone?.();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  }
  return (
    <div data-testid="whole-class-quick" className="mt-3 bg-white rounded-2xl p-3 shadow-sm space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-semibold text-slate-800 flex items-center gap-1.5"><Users size={15} className="text-pink-600" />Whole class in one tap</span>
        <Select value={cls || keys[0]} onValueChange={setCls}>
          <SelectTrigger data-testid="wcq-class" className="h-8 w-auto min-w-[200px] text-xs"><SelectValue /></SelectTrigger>
          <SelectContent>{keys.map((k) => <SelectItem key={k} value={k}>{k} ({groups[k].length})</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {FIELDS.map(([k, label, Icon]) => (
        <div key={k} className="flex flex-wrap items-center gap-1.5">
          <span className="text-xs text-slate-500 w-20 flex items-center gap-1"><Icon size={12} />{label}</span>
          {QUICK[k].map((c) => (
            <button key={c} type="button" disabled={busy} data-testid={`wcq-${k}-${c.replace(/\W+/g, "-").toLowerCase()}`} onClick={() => apply(k, label, c)}
              className="px-2.5 py-1 rounded-full text-xs font-medium border border-slate-200 bg-white text-slate-600 hover:border-pink-300 hover:bg-pink-50 transition-colors disabled:opacity-50">{c}</button>
          ))}
        </div>
      ))}
    </div>
  );
}
